export default __webpack_public_path__ + "static/media/F9C44182-1F45-4355-9CBD-C5C1828D37A7_1_105_c.1ec90bed.jpg";